import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estudios',
  templateUrl: './estudios.component.html',
  styles: [
  ]
})
export class EstudiosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
